import { Drawer } from "@material-ui/core";
import MeditocMenuList from "./MeditocMenuList";
import { useLayout } from "../../context/LayoutContext";
import { useStyle } from "../../context/StyleContext";

export default function MeditocDrawerLeft() {
    const { classes } = useStyle();
    const { openMenuDrawer, handleOpenMenu } = useLayout();

    return (
        <Drawer
            BackdropProps={{ className: classes.drawerColor }}
            PaperProps={{ className: classes.paperColor }}
            anchor="left"
            open={openMenuDrawer}
            onClose={handleOpenMenu(false)}
        >
            <div className={classes.list + " bg-color-1 color-0"} role="presentation" onKeyDown={handleOpenMenu(false)}>
                <MeditocMenuList />
            </div>
        </Drawer>
    );
}
